import { PaginationDefinition } from '../definition';

class PageNumberParser {
	public getPageNumberFromUrl(paramsPage: string | undefined, queryPage: string | undefined): number {
		const pageNumber = PaginationDefinition.DEFAULT_PAGE_NUMBER;

		if (paramsPage === PaginationDefinition.PAGE_TWO) {
			return 2;
		}

		if (queryPage !== undefined) {
			const tempPageNumber = Number(queryPage);
			if (Number.isInteger(tempPageNumber)) {
				return tempPageNumber;
			}
		}
		return pageNumber;
	}
}

export default new PageNumberParser();
